import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    chatWithSales: string;
    upgradeHeader: (title: string) => string | React.ReactNode;
    upgradeTo: string;
    featureNotAvailableAdobe: string;
    contactAdminAdobe: string;
    contactOwnerToUpgrade: (ownerName: string, ownerEmail: string) => string | React.ReactNode;
    priceEnterprise: string;
    pricePaid: (formattedPrice: string, period: string) => string | React.ReactNode;
    comparePlansEnterprise: string;
    comparePlans: string;
    close: string;
    subHeaders: {
        /** Sub-header for allowed domains feature */
        allowedDomains: string;
        /** Sub-header for archival storage feature */
        archivalStorage: string;
        /** Sub-header for asset lifecycle management feature */
        assetLifecycleManagement: string;
        /** Sub-header for comment attachments feature */
        commentAttachments: string;
        /** Sub-header for custom branded emails feature */
        customBrandedEmails: string;
        /** Sub-header for custom branded presentations feature */
        customBrandedPresentations: string;
        /** Sub-header for custom branded shares feature */
        customBrandedShares: string;
        /** Sub-header for custom sort feature */
        customSort: string;
        /** Sub-header for devices feature */
        devices: string;
        /** Sub-header for disable team member invites feature */
        disableTeamMemberInvites: string;
        /** Sub-header for DRM feature */
        drm: string;
        /** Sub-header for forensic watermarking feature */
        forensicWatermarking: string;
        /** Sub-header for 4K playback feature */
        fourKPlayback: string;
        /** Sub-header for HDR feature */
        hdr: string;
        /** Sub-header for mounted storage feature */
        mountedStorage: string;
        /** Sub-header for mounted storage overprovisioning feature */
        mountedStorageOverprovisioningAllowed: string;
        /** Sub-header for natural language search feature */
        naturalLanguageSearch: string;
        /** Sub-header for passphrase-protected shares feature */
        passwordProtectedShares: string;
        /** Sub-header for restricted folders feature */
        restrictedFolders: string;
        /** Sub-header for restricted projects feature */
        restrictedProjects: string;
        /** Sub-header for reel player feature */
        reelPlayer: string;
        /** Sub-header for content security settings feature */
        resourceControlPolicies: string;
        /** Sub-header for secure sharing feature */
        secureSharing: string;
        /** Sub-header for semantic search feature */
        semanticSearch: string;
        /** Sub-header for session-based watermarking feature */
        sessionBasedWatermarking: string;
        /** Sub-header for share link expiration feature */
        shareLinkExpiration: string;
        /** Sub-header for share link security feature */
        shareLinkSecurity: string;
        /** Sub-header for share lists feature */
        shareLists: string;
        /** Sub-header for static watermark feature */
        staticWatermark: string;
        /** Sub-header for storage connect feature */
        storageConnect: string;
        /** Sub-header for internal comments feature */
        teamOnlyComments: string;
        /** Sub-header for transcription feature */
        transcription: string;
        /** Sub-header for unlimited watermark templates feature */
        unlimitedWatermarkTemplates: string;
        /** Sub-header for upload links feature */
        uploadLinks: string;
        /** Sub-header for user groups feature */
        userGroups: string;
        /** Sub-header for user management feature */
        userManagement: string;
    };
    enterprise: string;
    addOn: string;
};
export type Deps = {
    Text: any;
    StyledLink: any;
};
export default {
    DEFINE(_messages: Text, { Text, StyledLink }: Deps): void {
        return Object.defineProperties(this, {
            /** Button text to chat with sales team */
            chatWithSales: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.chatWithSales?c=3ksct8gc0jc9r", defaultMessage: "Chat with Sales" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Header text for subscribe button */
            upgradeHeader: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (title: string) => __intl__.intl().formatMessage({ id: "PlanDetails.upgradeHeader?c=20hy830ss0qh", defaultMessage: "Subscribe to {title}" }, { title: title }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text prefix before plan title */
            upgradeTo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.upgradeTo?c=2lqmy5gcpfyqy", defaultMessage: "Upgrade to" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text when feature not available on managed by Adobe plan */
            featureNotAvailableAdobe: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.featureNotAvailableAdobe?c=1vdztocgrcdl0", defaultMessage: "This feature is not available on your plan." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text to contact admin for Adobe plans */
            contactAdminAdobe: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.contactAdminAdobe?c=1c4sxknq7xt21", defaultMessage: "Contact your admin for assistance." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text to contact owner to upgrade - includes owner name and email */
            contactOwnerToUpgrade: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (ownerName: string, ownerEmail: string) => __intl__.intl().formatMessage({ id: "PlanDetails.contactOwnerToUpgrade?c=2ctzxsqsmqwfy", defaultMessage: "<jsx>Contact  <Text>{ownerName}</Text>  <StyledLink>({ownerEmail})</StyledLink>  to upgrade to this plan.</jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), Text: (__children__: React.ReactNode) => <Text color="primary" display="inline" style={{ overflowWrap: "break-word" }} variant="secondary">{React.Children.toArray(__children__)}</Text>, ownerName: ownerName, StyledLink: (__children__: React.ReactNode) => <StyledLink $inlineBlock={true} href={`mailto:${ownerEmail}`} target="_blank">{React.Children.toArray(__children__)}</StyledLink>, ownerEmail: ownerEmail }));
                },
                enumerable: true,
                configurable: true
            },
            /** Price text for enterprise tier */
            priceEnterprise: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.priceEnterprise?c=ipb8ueit5k1f", defaultMessage: "Custom pricing \u00B7 " }));
                },
                enumerable: true,
                configurable: true
            },
            /** Price text for paid plans */
            pricePaid: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (formattedPrice: string, period: string) => __intl__.intl().formatMessage({ id: "PlanDetails.pricePaid?c=2ld68uwaugo6h", defaultMessage: "{formattedPrice}/ {period} + tax per user \u00B7 " }, { formattedPrice: formattedPrice, period: period }));
                },
                enumerable: true,
                configurable: true
            },
            /** Link text for enterprise tier */
            comparePlansEnterprise: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.comparePlansEnterprise?c=g6zay7fzk8i", defaultMessage: "See Current Plan Details" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Link text for other tiers */
            comparePlans: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.comparePlans?c=2yk56yag0cw84", defaultMessage: "Compare plans" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Close button label */
            close: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.close?c=1h3mba94p9xl7", defaultMessage: "Close" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Sub-header texts for each feature unlock */
            subHeaders: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Sub-header for allowed domains feature */
                        allowedDomains: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.allowedDomains?c=18iq6k97jpyyp", defaultMessage: "Unlock Allowed Domains" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for archival storage feature */
                        archivalStorage: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.archivalStorage?c=1zetr194a9ook", defaultMessage: "Unlock Archival Storage" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for asset lifecycle management feature */
                        assetLifecycleManagement: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.assetLifecycleManagement?c=3eccao4ygaqp5", defaultMessage: "Unlock Asset Lifecycle Management" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for comment attachments feature */
                        commentAttachments: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.commentAttachments?c=2ggdeh1dog8ns", defaultMessage: "Unlock Comment Attachments" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for custom branded emails feature */
                        customBrandedEmails: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.customBrandedEmails?c=3cnvi1708tbg4", defaultMessage: "Unlock Custom-Branded Emails" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for custom branded presentations feature */
                        customBrandedPresentations: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.customBrandedPresentations?c=3y7c3f2t23se", defaultMessage: "Unlock Custom-branded Presentations" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for custom branded shares feature */
                        customBrandedShares: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.customBrandedShares?c=3p7kzib94tbvz", defaultMessage: "Unlock Custom-Branded Shares" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for custom sort feature */
                        customSort: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.customSort?c=289o3babjft5r", defaultMessage: "Unlock Custom Sort" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for devices feature */
                        devices: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.devices?c=3synyrcsmot19", defaultMessage: "Unlock Devices" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for disable team member invites feature */
                        disableTeamMemberInvites: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.disableTeamMemberInvites?c=3k8i6hil5ralv", defaultMessage: "Unlock Disabling Team Member Invites" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for DRM feature */
                        drm: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.drm?c=uk8nt5th7n77", defaultMessage: "Unlock DRM" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for forensic watermarking feature */
                        forensicWatermarking: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.forensicWatermarking?c=3jqr66p8spm12", defaultMessage: "Unlock Forensic Watermarking" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for 4K playback feature */
                        fourKPlayback: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.fourKPlayback?c=r82hkoccszf9", defaultMessage: "Unlock 4K UHD Playback" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for HDR feature */
                        hdr: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.hdr?c=2hsijnw85ghi1", defaultMessage: "Unlock HDR" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for mounted storage feature */
                        mountedStorage: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.mountedStorage?c=v4d3bqs6h8sz", defaultMessage: "Unlock Mounted Storage" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for mounted storage overprovisioning feature */
                        mountedStorageOverprovisioningAllowed: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.mountedStorageOverprovisioningAllowed?c=3sqx20tm8xrym", defaultMessage: "Unlock Mounted Storage Overprovisioning" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for natural language search feature */
                        naturalLanguageSearch: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.naturalLanguageSearch?c=tcodi3g5i55p", defaultMessage: "Unlock Natural Language Search" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for passphrase-protected shares feature */
                        passwordProtectedShares: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.passwordProtectedShares?c=32s778rkoim3j", defaultMessage: "Unlock Passphrase-Protected Shares" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for restricted folders feature */
                        restrictedFolders: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.restrictedFolders?c=3b1e0y09uguq", defaultMessage: "Unlock Restricted Folders" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for restricted projects feature */
                        restrictedProjects: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.restrictedProjects?c=27k7a6xajnrgs", defaultMessage: "Unlock Restricted Projects" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for reel player feature */
                        reelPlayer: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.reelPlayer?c=2e42zyhfvj099", defaultMessage: "Unlock Reel Layout" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for content security settings feature */
                        resourceControlPolicies: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.resourceControlPolicies?c=otpdfgikciub", defaultMessage: "Unlock Content Security Settings" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for secure sharing feature */
                        secureSharing: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.secureSharing?c=8ubww3x7t5dz", defaultMessage: "Unlock Secure Sharing" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for semantic search feature */
                        semanticSearch: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.semanticSearch?c=vkrgn7yy6jpi", defaultMessage: "Unlock Semantic Search" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for session-based watermarking feature */
                        sessionBasedWatermarking: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.sessionBasedWatermarking?c=1liwyqrx5dv3w", defaultMessage: "Unlock Session-Based Watermarking" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for share link expiration feature */
                        shareLinkExpiration: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.shareLinkExpiration?c=1woa55glxkjfj", defaultMessage: "Unlock Share Link Expiration" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for share link security feature */
                        shareLinkSecurity: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.shareLinkSecurity?c=2pwgy6wtr3ihb", defaultMessage: "Unlock Share Link Security & Permissions" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for share lists feature */
                        shareLists: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.shareLists?c=2ddv3zhcsh0c4", defaultMessage: "Unlock Share Lists" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for static watermark feature */
                        staticWatermark: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.staticWatermark?c=1j84x9krou19d", defaultMessage: "Unlock Static Watermark" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for storage connect feature */
                        storageConnect: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.storageConnect?c=3j23lt3rv9rz8", defaultMessage: "Unlock Storage Connect" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for internal comments feature */
                        teamOnlyComments: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.teamOnlyComments?c=1oeh9dlcibpss", defaultMessage: "Unlock Internal Comments" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for transcription feature */
                        transcription: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.transcription?c=3aw7w19zc0tof", defaultMessage: "Unlock Transcription" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for unlimited watermark templates feature */
                        unlimitedWatermarkTemplates: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.unlimitedWatermarkTemplates?c=11hossgkmfzxi", defaultMessage: "Unlock Unlimited Watermark Templates" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for upload links feature */
                        uploadLinks: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.uploadLinks?c=xwb43vgpyvxc", defaultMessage: "Unlock Upload Links" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for user groups feature */
                        userGroups: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.userGroups?c=2mw1ftu9o6v3y", defaultMessage: "Unlock User Groups" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Sub-header for user management feature */
                        userManagement: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.subHeaders.userManagement?c=1j87wd2tth1fh", defaultMessage: "Unlock User Management" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Enterprise badge text */
            enterprise: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.enterprise?c=3sujypxiqmqkx", defaultMessage: "Enterprise" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Add-on badge text */
            addOn: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "PlanDetails.addOn?c=169mhanwl2occ", defaultMessage: "Add-On" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
